import React from 'react';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => (
  <div role="alert" className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-800">
    <div className="flex items-start gap-2">
      <svg className="h-4 w-4 mt-0.5 shrink-0 text-red-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden>
        <path fillRule="evenodd" d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm.75-11.5a.75.75 0 0 0-1.5 0V11a.75.75 0 0 0 1.5 0V6.5Zm-.75 7.75a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75Z" clipRule="evenodd" />
      </svg>
      <span>{message}</span>
    </div>
  </div>
);

export default ErrorMessage;
